import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function useQuery() {
	const { search } = useLocation();

	return useMemo(() => new URLSearchParams(search), [search]);
}

export default function useParamsState<T>(key: string = "tab", defaultValue: T): [T, (newValue: T) => void] {
	const { pathname, search } = useLocation();
	const navigate = useNavigate();
	const url = new URLSearchParams(search);
	const query = useQuery();

	const stringValue = url.get(key);
	let value = undefined;

	if (stringValue && typeof defaultValue === "string") value = stringValue;
	else if (stringValue) {
		value = JSON.parse(stringValue);
	}

	if (typeof value === "undefined") value = defaultValue;

	return [
		value,
		(newValue: T) => {
			if (newValue === undefined || newValue === null) {
				query.delete(key);
			} else {
				query.set(key, JSON.stringify(newValue));
			}
			navigate({
				pathname,
				search: query.toString(),
			});
		},
	];
}
